<template>
  <div>
    <!-- <vue-element-loading :active="loading" spinner="bar-fade-scale" color="#5dc596" :is-full-screen="true" /> -->
    <div class="md-layout-item">
      <div class="md-layout">
        <div
          class="md-layout-item md-size-50 md-medium-size-100 md-small-size-100"
        >
          <md-card style="margin: 0px">
            <md-card-header class="md-card-header-icon">
              <div
                class="card-icon"
                style="background-color: #425276 !important"
              >
                <i class="fas fa-industry"></i>
              </div>
              <span style="font-size: large; font-weight: 500">Industry</span>
            </md-card-header>
            <md-card-content>
              <md-table
                :value="queriedData"
                :md-sort.sync="currentSort"
                :md-sort-order.sync="currentSortOrder"
                :md-sort-fn="customSort"
                class="paginated-table table-striped table-hover"
              >
                <md-table-toolbar>
                  <md-field>
                    <md-input
                      type="search"
                      class="mb-3"
                      clearable
                      style="width: 200px"
                      placeholder="Search records"
                      v-model="searchQuery"
                    >
                    </md-input>
                  </md-field>
                  <!-- <md-button class="md-info md-round notice-modal" @click="dispshowCard" style="float:right;">
              Add
            </md-button> -->
                  <md-button
                    style="
                      z-index: 9999 !important;
                      position: absolute !important;
                      bottom: 1vh !important;
                      right: 10px !important;
                    "
                    class="md-info md-just-icon md-round"
                    @click="dispshowCard"
                  >
                    <md-icon>add</md-icon>
                  </md-button>
                </md-table-toolbar>
                <md-table-row slot="md-table-row" slot-scope="{ item }">
                  <md-table-cell md-label="Category Name" md-sort-by="name">
                    {{ item.name }}
                  </md-table-cell>
                  <md-table-cell md-label="Active">
                    <md-checkbox v-model="item.status" disabled></md-checkbox>
                  </md-table-cell>
                  <md-table-cell md-label="Actions">
                    <md-button
                      class="md-just-icon md-warning md-simple"
                      @click.native="handleEdit(item)"
                    >
                      <md-icon>dvr</md-icon>
                    </md-button>
                    &emsp;&nbsp;&nbsp;&nbsp;
                    <md-button
                      class="md-just-icon md-danger md-simple"
                      @click.native="handleDelete(item)"
                    >
                      <md-icon>close</md-icon>
                    </md-button>
                  </md-table-cell>
                </md-table-row>
              </md-table>
            </md-card-content>
            <md-card-actions md-alignment="space-between">
              <div class="">
                <p class="card-category">
                  Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
                </p>
              </div>
              <pagination
                class="pagination-no-border pagination-success"
                v-model="pagination.currentPage"
                :per-page="pagination.perPage"
                :total="total"
              >
              </pagination>
            </md-card-actions>
          </md-card>
        </div>
        <div
          class="md-layout-item md-size-50 md-medium-size-100 md-small-size-100"
          v-if="showCard"
        >
          <md-card>
            <md-card-header class="md-card-header-icon headtable">
              <div class="card-icon" style="background-color: rgb(66, 82, 118)">
                <md-icon>assignment</md-icon>
              </div>
              <span style="font-size: large; font-weight: 500"
                >Add Industry Category Details</span
              >
            </md-card-header>
            <md-card-content>
              <div
                class="
                  md-layout-item
                  md-size-100
                  md-small-size-100
                  md-medium-size-100
                "
              >
                <md-field>
                  <label for="name">Category Name</label>
                  <md-input name="name" v-model="master.name" />
                </md-field>
              </div>
              <div
                class="
                  md-layout-item
                  md-size-100
                  md-small-size-100
                  md-medium-size-100
                "
              >
                <md-checkbox v-model="master.status">Active</md-checkbox>
              </div>
              <div
                class="md-layout-item md-small-size-100 md-medium-size-20"
                style="text-align: right"
              >
                <button
                  type="submit"
                  @click="addMaster()"
                  class="myButtonStyleSuccess"
                  style="width: 20%; margin-right: 10px"
                >
                  Save
                </button>
                <button
                  type="submit"
                  @click="cancelAdd()"
                  class="myButtonStyleDefault"
                  style="width: 20%"
                >
                  Cancel
                </button>
              </div>
              <!-- <div class="row3" style="float:right;">
                  <div class="md-layout-item md-small-size-100 md-medium-size-20">
                    <md-button type="submit" @click="addMaster()" class="md-success">
                      save
                    </md-button>
                    <md-button type="submit" @click="cancelAdd()">
                      Cancel
                    </md-button>
                  </div>
                </div> -->
            </md-card-content>
          </md-card>
        </div>
        <div
          class="md-layout-item md-size-50 md-small-size-100 md-medium-size-100"
          v-else-if="showupdate"
        >
          <md-card>
            <md-card-header class="md-card-header-icon headtable">
              <div class="card-icon" style="background-color: rgb(66, 82, 118)">
                <md-icon>assignment</md-icon>
              </div>
              <span style="font-size: large; font-weight: 500"
                >Edit Industry Category Details</span
              >
            </md-card-header>
            <md-card-content>
              <div
                class="md-layout-item md-small-size-100 md-medium-size-20"
                style="width: 50%"
              >
                <md-field>
                  <label for="name">Category Name</label>
                  <md-input name="name" v-model="master.name" />
                </md-field>
              </div>
              <div
                class="
                  md-layout-item
                  md-size-100
                  md-small-size-100
                  md-medium-size-100
                "
              >
                <md-checkbox v-model="master.status">Active</md-checkbox>
              </div>
              <div
                class="md-layout-item md-small-size-100 md-medium-size-20"
                style="text-align: right"
              >
                <button
                  type="submit"
                  @click="updateMaster()"
                  class="myButtonStyleSuccess"
                  style="width: 20%; margin-right: 10px"
                >
                  Update
                </button>
                <button
                  type="submit"
                  @click="cancelUpdate()"
                  class="myButtonStyleDefault"
                  style="width: 20%"
                >
                  Cancel
                </button>
              </div>
              <!--  <div class="row3" style="float:right;">
                <div class="md-layout-item md-small-size-100 md-medium-size-20">
                  <md-button @click="updateMaster" class="md-success">
                    Update
                  </md-button><md-button type="submit" @click="cancelUpdate()">
                      Cancel
                    </md-button>
                </div>
              </div>-->
            </md-card-content>
          </md-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Pagination } from "@/components";
import Fuse from "fuse.js";
import Swal from "sweetalert2";
import $ from "jquery";
import { APIService } from "../../../../apiservice";
export default {
  components: {
    Pagination,
    //   Modal
  },
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    },
  },
  props: {
    userid: {
      type: String,
    },
  },
  data() {
    return {
      currentSort: "name",
      currentSortOrder: "asc",
      loading: false,
      showCard: false,
      showupdate: false,
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      master: {
        name: "",
        type: "industry",
        status: true,
        createdBy: "",
      },
      noticeModal: false,
      updatemodal: false,
      //   footerTable: ["Full Name", "Email", "Country", "Created", "Status", "Actions"],
      searchQuery: "",
      propsToSearch: ["name", "email", "status"],
      tableData: [],
      transactName: [],
      searchedData: [],
      fuseSearch: null,
      tempMaster: {},
    };
  },
  created: function () {
    this.getMaster();
  },
  methods: {
    getMaster() {
      let self = this;
      let data = { type: "industry", createdBy: this.userid };
      APIService.getMasterData(data).then((res) => {
        if (res.status == 200) {
          self.tableData = res.data;
          this.fuseSearch = new Fuse(this.tableData, {
            keys: ["name"],
            threshold: 0.3,
          });
        }
      });
    },
    cancelUpdate() {
      this.showupdate = false;
    },
    cancelAdd() {
      this.showCard = false;
    },
    dispshowCard() {
      this.master.name = "";
      this.master.status = true;
      this.showCard = true;
      this.showupdate = false;
    },
    addMaster() {
      let self = this;
      let i = this;
      let data = this.tableData.filter((n) => {
        if (self.master.name == "") {
          return true;
        } else if (n.name == self.master.name) {
          return true;
        } else {
          return false;
        }
      });

      if (!data[0]) {
        self.master.createdBy = this.userid;
        APIService.saveMasterData(self.master).then((res) => {
          if (res.status == 200) {
            self.showCard = false;
            self.getMaster();
          }
        });
      } else {
        this.$notify({
          timeout: 2500,
          message: "industry list is already defined.",
          icon: "add_alert",
        });
      }
    },
    updateMaster() {
      let self = this;
      self.tempMaster.name = self.master.name;
      self.tempMaster.status = self.master.status;
      APIService.editMaster(self.tempMaster).then((res) => {
        if (res.status == 200) {
          this.showupdate = false;
          self.getMaster();
        }
      });
    },
    customSort(value) {
      return value.sort((a, b) => {
        const sortBy = this.currentSort;
        a[sortBy] = a[sortBy] ? a[sortBy] : "";
        b[sortBy] = b[sortBy] ? b[sortBy] : "";
        if (this.currentSortOrder === "desc") {
          return a[sortBy].localeCompare(b[sortBy]);
        }
        return b[sortBy].localeCompare(a[sortBy]);
      });
    },
    handleEdit(item) {
      let self = this;
      self.tempMaster = {};
      self.master.name = item.name;
      self.master.status = item.status;
      self.tempMaster = item;
      this.showCard = false;
      this.showupdate = true;
    },
    handleDelete(item) {
      // Swal.fire({
      //   title: "Are you sure?",
      //   text: `You won't be able to revert this!`,
      //   type: "warning",
      //   showCancelButton: true,
      //   confirmButtonClass: "md-button md-success",
      //   cancelButtonClass: "md-button md-danger",
      //   confirmButtonText: "Yes, delete it!",
      //   buttonsStyling: false
      // }).then(result => {
      //   if (result.value) {
      //     this.deleteRow(item);
      //   }
      // });
      this.deleteRow(item);
    },
    deleteRow(item) {
      APIService.removeMaster(item).then((res) => {
        if (res.status == 200) {
          this.getMaster();
        }
      });
    },
  },
  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery(value) {
      let result = this.tableData;
      if (value !== "") {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    },
  },
};
</script>

<style lang="css" scoped>
.md-card .md-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}

.row1 {
  width: 50%;
  position: relative;
  top: 20px;
  float: right;
}

.row2[data-v-3984c662] {
  width: 50%;
  position: relative;
  top: 20px;
}

.emailTab {
  width: 30% !important;
}

.modalstyle {
  padding-left: 45%;
}
</style>